export enum ReferralType {
  True = 'true',
  False = 'false',
  NotInterested = 'not_interested',
}
